import slick from '../libs/slick';


export default {
    init() {
    },
    finalize() {
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js